module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-11",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('span', {
    staticClass: "Serif_Bold _idGenCharOverride-1"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Opening"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("A")]), _vm._v("llie pulled the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nal "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory pad "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om her typewriter and care"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("lly separated the top sheet and the copies, screwing up the messy black carbons and throwing them in the bin. Top copy "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the news desk, second copy "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the copy ta"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("er, third copy "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the picture desk, and the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ded pink sheet "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r her own de"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("sk drawer.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("She added each of the pages to the bottom of its pile then did a la"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("rea")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("through")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Type01"
  }, [_vm._v("Station "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" in Glasgow got a surprise ye"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("erday when a train arrived with an unexpected extra "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("passenger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("Jenny Forsyth went into labour on the 2 p.m. Waverley to Queen Street train which had been "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("randed in a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("snowdri")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("But thanks to the quick wits of guard "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("omas Mulrine, 47, Jenny arrived in Queen Street "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ation as the new mother of a bouncing"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" baby boy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("Jenny, 23, and her boy"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("iend Stephen Hamilton, 25, were returning to their home in White Street, Partick, when the drama"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" un")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("lded.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("Heavy snow had blocked the line between Falkirk High and Linlithgow, leaving the train"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("randed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("Be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re the snowplough could "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("ee the trapped carriages, baby Craig decided to put in an early appearance. Alerted by Jenny’s screams of pain, Mr Mulrine took over and delivered her son to applause "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om her "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("llow p"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("assengers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("And if that wasn’t drama enough, Stephen was so pleased by the sa"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v(" arrival of his son that he got down on one knee and proposed"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" to Jenny.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("A delighted Jenny said, ‘If I’d known that was all it would take to get him to ask me, I’d have "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("llen pregnant "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ages ago.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e proud dad said, ‘Craig wasn’t due "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r another "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rtnight so we thought it would be "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ne to go through to Edinburgh to bring in the New Year with Jenny’s mum and dad. I never thought in a million years she’d end up giving birth on "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("the train.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("‘I don’t know what would have happened if the guard hadn’t "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("epped in. He was the hero of "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("the hour.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("But Mr Mulrine denied he’d done anything heroic. ‘It’s my job to take care of the passengers. I’ve never had to deliver a baby be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re, though. And I hope I never have to do it again. Luckily my wi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v(" had one of our three children at home, so I did have some idea of what to do. But it was a big responsibility. I’m ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" glad it ended as well a"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("s it did.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e train was "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nally "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("eed half an hour later and completed its journey to Glasgow without any more "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("surprises.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type02"
  }, [_vm._v("Mr Mulrine radioed ahead so there was an ambulance waiting to rush mother and baby to nearby Glasgow Royal In"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("rmary where they were checked over by medical "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" who pronounced both to be "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("t an"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("d healthy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Type03"
  }, [_vm._v("A spokesman "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r British Rail said, ‘We’re delighted that Craig arrived sa"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("ly. We will be giving this very special baby a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("ee train travel pass "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("r li")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Fourteen paragraphs. A touch on the lengthy side, but it was a slow news day and she might get away with it. She’d snapped half a dozen pics of the happy "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("mily, with and without the sheepish "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("omas Mulrine, and handed the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("lm over to the picture desk as soon as she’d arrived in the o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce. She’d already had to endure the "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("heavy")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("handed")]), _vm._v(" banter of the picture editor and his minions. ‘At lea"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" they’ve all got their eyes open,’ he’d said grudgingly, a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("er taking the piss out of the Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("mas party photographs that took up the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" half of"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" the ")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("lm.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie di"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ributed her copy and was hal"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fw")]), _vm._v("ay back to her seat when Gavin, the night news editor, shouted her name. She made her way cautiously back to the "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("U")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("shaped")]), _vm._v(" arrangement of desks where the news executives held court. Gavin Todd was a skinny whelp of a man whose suits hung on him as if his bony shoulders were a hanger. Everything about him was a work in progress, though not in the right direction – his hair was thinning and greying, his po"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ure had grown even more hunched in the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("w months Allie had been there, and the proportion of whisky to tea in the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ermos he brought to work seemed to be rising "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("eadily. Every night, he’d "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("art on the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("ask within ten minutes of the day shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" leaving. At nine on the dot, he’d be o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" to the pub "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r his break. She’d been there a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("w times and watched him sink "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ve large measures of whisky – ‘wee goldies’, he called them – in ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" over an hour. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("en he’d buy a quarter bottle to keep him going till he departed at some random point between one and two in th"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("She eyed him warily as she approached. Early in the shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(", Gavin resembled a normal, reasonable newsdesk jockey. Which was to say, dealing with him was a bit like juggling a grenade whose pin was on the point of clattering to the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("oor. But as the whisky took hold, his speech and his brain grew slurred and his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("u"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ration spilled over into querulous complaint. ‘"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("is copy,"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("’ he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Yeah?’ Better not to engage till you were sure which Gavin you’d be dea"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ling with.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘You were there, right? You were on "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("the spot?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie nodded. ‘Ay"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e, I was.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘So what’s this?’ He slapped the sheets of paper again"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" the edge of the desk. ‘How come it’s not an “I” piece? You should be milking it, Burns. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e other papers’ll have the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory by now. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e only thing making this exclusive is you bei"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ng there.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘But it’s not my "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory, Gav. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e drama, that’s all about Jenny and the guard and the marriage proposal.’ She "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("lt a crushing sensation in her che"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(". Was she ever going to get the hang of this? Everybody else seemed to operate on in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("inct, an in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("inct she didn’"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("t possess.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re Gavin could get into her ribs again, the night editor materialised at his elbow. Arnie Anderson was the opposite of Gavin in almo"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" every respect. Corpulent and cheery, "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("black")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("haired")]), _vm._v(" and bearded, he took his breaks in the o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce canteen rather than the pub, "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("u"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ng himself with the "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("home")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("made")]), _vm._v(" soup and pies that were permanent "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("xtures on the menu. ‘Nice wee piece, Burns,’ "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("he boomed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Should have been an “I” piece,’ Gavin whined. ‘"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e lassie was there. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at’s the e"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("xclusive.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Gavin, Gavin,’ Arnie let out an exaggerated sigh of disappointment. He gave an expansive ge"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ure at the picture desk with his bee"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fy")]), _vm._v(" arm. ‘"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e pics, that’s the exclusive. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at’s the splash. Something cheer"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("l in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ead of the endless bloody blizzard "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ories that everybody’s sick of already. We’ll go across "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ve columns with the pic. But we’ll have to give it a turn on to page two to get all the copy in. And that means we’ve got room "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r you to do a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ve")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("par")]), _vm._v(" sidebar about your dramatic train ride, Burns.’ He dismissed her with a wiggle of his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ngers. ‘Are you "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ill here?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie retreated, leaving Arnie leaning over Gavin’s shoulder, pawing through the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ories in his basket. She inserted a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("esh copy pad into her typewriter and "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ared at the blank page with a mixture of terror and hatred. ‘I need it by nine,’ Arnie shouted at her as he turned towards the back bench, where the decisions about layout and content "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("were made.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Fuck,’ she muttered. Like all her "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("llow graduate trainees, she’d read her Tom Wol"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v(" and her Joan Didion, her Nick Tomalin and her Truman Capote. She’d dreamed of swelling the ranks of the New Journalism. But working "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" on a local evening paper and now on a daily tabloid had been a rude awakening. Even the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("ature writers wrote in tabloidese, a weird jargon of clichés and shortcuts. Anyone with cancer was ‘"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ghting bravely’; any woman over the age of "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fift")]), _vm._v("y was a ‘battling granny’; under "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fift")]), _vm._v("y, chances were she’d be a ‘blonde bombshell’. By the time the subs had "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nished with Allie’s copy, she’d have bet a pound to a gold watch that Craig would be a ‘miracle baby’. So where did her ‘I’ piece sit in that shall"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ow puddle?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie considered the advice an older colleague had given her in her early days covering magi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("rates courts and council meetings in Newca"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("le. ‘How would you tell it to your pals in the pub?’ he’d asked. ‘Ten times out of nine that gives you yo"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ur intro.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I am NEVER going to have a baby,’ was what sprang to mind. She didn’t need a sub to tell her that wasn’t the place to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("art a "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Clarion")]), _vm._v(" "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory. In spite of the "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("anti")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("Catholic")]), _vm._v(" sentiment that "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ill "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("elled the paper’s employment policy, mothers were madonnas in this news"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" universe.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie rummaged in her bag "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r her cigarettes: Silk Cut, the smoke of choice "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r everyone pretending they were weaning themselves o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" tobacco by going "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the milde"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" possible hit. She tried to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ick to ten a day, and mo"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ly she succeeded. Tonight, she might not make it, she conceded wryly, lighting up with a disposable lighter. Another element of pretence – she wasn’t in this "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the long haul that a Zippo would signal. She inhaled deeply, her "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ngers deliberately covering the pinprick holes that were designed to allow some of the toxic smoke to dissipate be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re it reached the smoker. Who was she trying to kid, she"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" wondered.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("In the pause "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r thought that the cigarette o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffe")]), _vm._v("red her, she managed to come up with something she might get away with. ‘It was supposed to be a routine train journey. In"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ead, I witnessed a New Year miracle on the tracks between Edinburgh and Glasgow ye"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("erday.’ Already, she hate"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("d herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("She knocked out another "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("ur paragraphs that began with a scream, continued through "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("hand")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("holding")]), _vm._v(" and ended with what she thought was the only decent line in the piece. ‘My New Year’s resolution? Take a Fir"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" Ai"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("d course.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("As she typed the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nal sentence, Gavin slunk up behind her and looked over her shoulder. ‘Are you nearly done? Lucky there’s no news to speak of. Arnie’s giving you a big chance here, the splash and a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("turnover.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Allie yanked the copy pad "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the typewriter. ‘"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("All done.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Gavin snatched the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om her and bu"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("led o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(", ready to take the credit "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r getting the words delivered in time "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" edition deadline. At the end of the line of desks he turned back to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ce her. ‘Don’t ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" sit there, Burns. Make yourself use"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("l. Away and get one of the drivers to take you on a round of calls. Remember, you’re only as good as your la"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("s")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("t")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" splash.’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6147a65a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-9.vue
// module id = 90
// module chunks = 0